import React from 'react';
import { MembershipModel } from 'services/EpdClient';
import styled from 'styled-components';

interface UserSettingsRolesTabProps {
  userId?: string;
  memberships: MembershipModel[];
}

const UserSettingsRolesTab: React.FC<UserSettingsRolesTabProps> = ({ userId, memberships }) => {
  return (
    <Container>
      <PlaceholderText>My Roles - Coming Soon</PlaceholderText>
    </Container>
    // <>
    //   {memberships.length > 0 ? (
    //     memberships.map((membership, index) => (
    //       <MembershipItem key={index}>
    //         <OrganisationName>{membership.companyName || 'N/A Organisation'}</OrganisationName>
    //         <RolePills>{membership.roleName}</RolePills>
    //       </MembershipItem>
    //     ))
    //   ) : (
    //     <Value>No membership information available.</Value>
    //   )}
    // </>
  );
};

const Container = styled.div`
  padding: 1rem 0;
`;

const PlaceholderText = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

export default UserSettingsRolesTab;